export function applyTheme(theme) {
  document.documentElement.setAttribute("data-theme", theme)
  localStorage.setItem("theme", theme)
}

export function initTheme() {
  const saved = localStorage.getItem("theme") || "light"
  applyTheme(saved)
}
